"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardApi = exports.Network = void 0;
const tslib_1 = require("tslib");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const buffer_1 = require("buffer");
const bitcoin = (0, tslib_1.__importStar)(require("bitcoinjs-lib"));
const helpers_1 = require("./helpers");
const btcNode_1 = require("../btcNode");
var Network;
(function (Network) {
    Network["TESTNET"] = "testnet";
    Network["MAINNET"] = "mainnet";
})(Network = exports.Network || (exports.Network = {}));
var DATA_TYPE;
(function (DATA_TYPE) {
    DATA_TYPE["ISSUES"] = "issues";
    DATA_TYPE["REDEEMS"] = "redeems";
    DATA_TYPE["VAULTS"] = "vaults";
    DATA_TYPE["EVENTS"] = "relay/events";
})(DATA_TYPE || (DATA_TYPE = {}));
var ENTITY_HISTORY_TYPE;
(function (ENTITY_HISTORY_TYPE) {
    ENTITY_HISTORY_TYPE["VAULTS"] = "vaults";
    ENTITY_HISTORY_TYPE["ISSUED"] = "issued";
    ENTITY_HISTORY_TYPE["REDEEMS"] = "redeemed";
})(ENTITY_HISTORY_TYPE || (ENTITY_HISTORY_TYPE = {}));
class DashboardApi {
    constructor(params) {
        this.loadDashboardConfig = async () => {
            const res = await axios_1.default.get(`${this.dashboardUrl}/monitor`);
            return res.data;
        };
        this.loadDataList = async (dataType, params) => {
            const res = await axios_1.default.get(`${this.dashboardUrl}/${dataType}/data`, {
                params,
            });
            return res.data;
        };
        this.addEvent = async (hash) => {
            const res = await axios_1.default.post(`${this.dashboardUrl}/events/add-by-hash`, {
                hash,
            });
            return res.data;
        };
        this.loadData = async (dataType, entityId) => {
            const res = await axios_1.default.get(`${this.dashboardUrl}/${dataType}/data/${entityId}`);
            return res.data;
        };
        this.loadIssue = async (issueId) => {
            return await this.loadData(DATA_TYPE.ISSUES, issueId);
        };
        this.loadRedeem = async (redeemId) => {
            return await this.loadData(DATA_TYPE.REDEEMS, redeemId);
        };
        this.loadVault = async (vaultId) => {
            return await this.loadData(DATA_TYPE.VAULTS, vaultId);
        };
        this.loadEvent = async (eventId) => {
            return await this.loadData(DATA_TYPE.EVENTS, eventId);
        };
        this.loadEventList = async (params) => {
            return this.loadDataList(DATA_TYPE.EVENTS, params);
        };
        this.loadIssueList = (params) => {
            return this.loadDataList(DATA_TYPE.ISSUES, params);
        };
        this.loadRedeemList = (params) => {
            return this.loadDataList(DATA_TYPE.REDEEMS, params);
        };
        this.loadVaultList = (params) => {
            return this.loadDataList(DATA_TYPE.VAULTS, params);
        };
        this.getVaultFreeOutputs = async (vault) => {
            const issues = await this.loadIssueList({ page: 0, size: 500, vault });
            const freeOutputs = [];
            let totalAmount = 0;
            let i = 0;
            const amount = 0;
            const getMax = true;
            while ((getMax || totalAmount < amount) && i < issues.content.length) {
                const issue = issues.content[i];
                const bech32Address = this.addressToBench32(issue.btcAddress);
                const txs = await this.btcNodeClient.loadTxsByAddress(bech32Address);
                const outputs = (0, helpers_1.getActualOutputs)(txs, bech32Address);
                outputs.forEach((out) => {
                    if (getMax || totalAmount < amount) {
                        totalAmount += Number(out.value);
                        freeOutputs.push(Object.assign(Object.assign({}, out), { id: issue.id, bech32Address }));
                    }
                });
                i++;
            }
            if (totalAmount < amount) {
                throw new Error('Vault BTC Balance is too low');
            }
            return freeOutputs;
        };
        this.loadVaultBalances = async (vault) => {
            const balances = {};
            const outs = await this.getVaultFreeOutputs(vault);
            outs.forEach((o) => (balances[o.bech32Address] =
                (balances[o.bech32Address] || 0) + o.value));
            const content = Object.keys(balances).map((key) => ({
                address: key,
                amount: balances[key],
            }));
            return {
                size: content.length,
                page: 0,
                totalPages: 1,
                content: content,
                totalElements: content.length,
            };
        };
        this.loadRelayInfo = async () => {
            const res = await axios_1.default.get(this.dashboardUrl + '/relay/info');
            return res.data;
        };
        this.loadInfo = async () => {
            const res = await axios_1.default.get(this.dashboardUrl + '/relay/events/info');
            return res.data;
        };
        this.loadLastEvent = async () => {
            const events = await this.loadEventList({
                size: 1,
                page: 0,
            });
            return events.content[0];
        };
        this._loadHistory = async (entityHistory, params) => {
            const res = await axios_1.default.get(`${this.dashboardUrl}/history/${entityHistory}`, { params });
            return res.data;
        };
        this.loadHistoryVault = async () => {
            return this._loadHistory(ENTITY_HISTORY_TYPE.VAULTS, {
                step: 'd',
            });
        };
        this.loadHistoryRedeem = async () => {
            return this._loadHistory(ENTITY_HISTORY_TYPE.REDEEMS);
        };
        this.loadHistoryIssue = async () => {
            return this._loadHistory(ENTITY_HISTORY_TYPE.ISSUED);
        };
        this.dashboardUrl = params.dashboardUrl;
        this.btcNodeUrl = params.btcNodeUrl;
        this.btcNodeClient = new btcNode_1.BTCNodeClient(this.btcNodeUrl);
        this.networkType = params.networkType;
    }
    addressToBench32(addressHex) {
        const prefix = this.networkType === Network.MAINNET ? 'bc' : 'tb';
        return bitcoin.address.toBech32(buffer_1.Buffer.from(addressHex.slice(2), 'hex'), 0, prefix);
    }
}
exports.DashboardApi = DashboardApi;
